import { jsx as a } from "react/jsx-runtime";
import { forwardRef as x, useState as b, useEffect as h } from "react";
import k from "./CheckboxInput.js";
import { tv as I } from "tailwind-variants";
const N = I({
  base: ["flex", "flex-col", "gap-2"]
}), w = x(
  ({ className: u, defaultValue: d = [], name: m, onChange: c, options: i = [], value: t }, n) => {
    const [s, f] = b(d), o = (e, l) => {
      const r = l ? [...s || [], e] : [...(s || []).filter((p) => p !== e)];
      f(r), c == null || c(r);
    };
    return h(() => {
      t !== void 0 && `${t}` != `${s}` && f(t || []);
    }, [t]), /* @__PURE__ */ a("ul", { className: N({ class: u }), ref: n, tabIndex: -1, children: i.map((e, l) => /* @__PURE__ */ a(
      k,
      {
        name: m,
        checked: s.includes(e.value),
        onChange: (r) => o(e.value, !!r),
        tagName: "li",
        ...e
      },
      l
    )) });
  }
);
w.displayName = "MultiCheckboxInput";
export {
  w as default
};
